/**
 * Application roles. Global (not tenant-scoped) per the schema contract:
 * the `role` table is global and `user_role` binds a user to a role within a tenant.
 */
export var Role;
(function (Role) {
    Role["Admin"] = "admin";
    Role["Manager"] = "manager";
    Role["Employee"] = "employee";
    /**
     * Sales (Michael, 2026-09-03). Created as an Entra app role on app registration
     * 5c1e9086 with the value `sales` — confirmed against Entra, because a value that
     * does not match the `roles` claim exactly would make every gate silently never fire.
     *
     * ⚠️ ORTHOGONAL, NOT A RANK. Sales is not more or less privileged than Manager: it
     * grants the Commission report and NOTHING else. That is why report access is a
     * permitted-role SET rather than the "at least this role" comparison it used to be —
     * see `canAccessReport`. Ranking Sales alongside Manager would have handed it PTO,
     * driver logs and the rest.
     */
    Role["Sales"] = "sales";
})(Role || (Role = {}));
/**
 * Every role value. Frozen to prevent mutation.
 *
 * Admin -> Manager -> Employee are in descending privilege order; Sales sits OUTSIDE
 * that line (see {@link Role.Sales}) and is listed last for that reason, not because it
 * is the least privileged. Nothing may treat this order as a hierarchy.
 */
export const ALL_ROLES = Object.freeze([
    Role.Admin,
    Role.Manager,
    Role.Employee,
    Role.Sales,
]);
const ROLE_VALUES = new Set(ALL_ROLES);
/** Runtime type guard: true when `x` is one of the known {@link Role} values. */
export function isRole(x) {
    return typeof x === 'string' && ROLE_VALUES.has(x);
}
//# sourceMappingURL=roles.js.map